// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const uid: CountryValidator<"CH"> = createValidator(
  "ch.uid",
  33,
);

export default uid;
export const compact = uid.compact;
export const format = uid.format;
export const validate = uid.validate;
export const generate = (): string =>
  uid.generate?.() ??
  (() => {
    throw new Error(
      "Validator ch.uid cannot generate values",
    );
  })();
